{
  "fields": {
    "email": "Email address",
    "password": "Password",
    "newPassword": "New password",
    "firstName": "First name",
    "lastName": "Last name",
    "name": "Display name",
    "role": "I am a"
  },
  "roles": {
    "student": "Student",
    "teacher": "Teacher"
  },
  "validation": {
    "required": "This field is required.",
    "email": "Enter a valid email address.",
    "passwordHint": "At least {{count}} characters. A whole sentence beats a complicated word.",
    "passwordTooShort": "Password must be at least {{count}} characters long."
  },
  "violations": {
    "too_short": "This password is too short.",
    "too_long": "This password is too long.",
    "too_common": "This password appears in known data breaches.",
    "contains_personal_data": "The password must not contain your name or email address.",
    "unknown": "This password does not meet the security policy."
  },
  "login": {
    "heading": "Sign in",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "forgotPassword": "Forgot your password?",
    "noAccount": "No account yet?",
    "registerLink": "Create an account"
  },
  "register": {
    "heading": "Create an account",
    "submit": "Create my account",
    "submitting": "Creating…",
    "haveAccount": "Already have an account?",
    "loginLink": "Sign in",
    "doneHeading": "Check your inbox",
    "doneBody": "A confirmation email is on its way. Open the link it contains to activate your account.",
    "goToLogin": "Go to sign in"
  },
  "verifyEmail": {
    "heading": "Confirming your address",
    "pending": "Verifying…",
    "success": "Your address is confirmed. You can now sign in.",
    "missingToken": "This link is incomplete. Use the one you received by email.",
    "expiredHelp": "The link may have expired. Request a new one from the sign-in page.",
    "goToLogin": "Go to sign in"
  },
  "forgotPassword": {
    "heading": "Forgotten password",
    "intro": "Enter your email address: if it matches an account, you will receive a reset link.",
    "submit": "Send the link",
    "submitting": "Sending…",
    "sent": "If that address matches an account, an email has just been sent. Check your spam folder too.",
    "backToLogin": "Back to sign in"
  },
  "resetPassword": {
    "heading": "New password",
    "submit": "Save",
    "submitting": "Saving…",
    "success": "Password changed. All your sessions have been closed: please sign in again.",
    "missingToken": "This link is incomplete. Use the one you received by email.",
    "goToLogin": "Go to sign in"
  },
  "session": {
    "restoring": "Restoring your session…"
  }
}
